'use strict';

module.exports = '3.27.0';



//////////////////
// WEBPACK FOOTER
// ./node_modules/algoliasearch/src/version.js
// module id = 381
// module chunks = 0